import type { ReactNode } from "react";
import { cn } from "./cn";

export interface SectionHeaderProps {
  title: ReactNode;
  eyebrow?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  filters?: ReactNode;
  trailing?: ReactNode;
  bordered?: boolean;
  className?: string;
}

export function SectionHeader({
  title,
  eyebrow,
  subtitle,
  actions,
  filters,
  trailing,
  bordered = true,
  className,
}: SectionHeaderProps) {
  return (
    <div
      className={cn(
        "bg-surface p-4 sm:p-6",
        bordered ? "border-b border-line" : undefined,
        className,
      )}
    >
      <div
        className={cn(
          "flex flex-col justify-between gap-3 sm:flex-row sm:items-center sm:gap-4",
          filters || trailing ? "mb-4" : undefined,
        )}
      >
        <div className="min-w-0">
          {eyebrow ? <div className="mb-2">{eyebrow}</div> : null}
          <h1 className="text-xl font-semibold text-content">{title}</h1>
          {subtitle ? <p className="mt-1 text-sm text-content-secondary">{subtitle}</p> : null}
        </div>
        {actions ? (
          <div className="flex shrink-0 items-center gap-2 self-start sm:self-auto">{actions}</div>
        ) : null}
      </div>

      {filters || trailing ? (
        <div className="flex min-w-0 flex-col justify-between gap-4 sm:flex-row sm:flex-wrap sm:items-center">
          {filters}
          {trailing}
        </div>
      ) : null}
    </div>
  );
}
